import Link from 'next/link';

import { ROUTES } from '@shared/constants/routes';

import cls from './Agreement.module.scss';

export const Agreement = () => (
  <div className={cls.agreement}>
    Входя в личный кабинет, вы соглашаетесь c{' '}
    <Link
      className={cls.accent}
      target={'_blank'}
      href={ROUTES.PUBLIC_OFFER}
    >
      условиями оферты
    </Link>{' '}
    и даете согласие на{' '}
    <Link
      className={cls.accent}
      target={'_blank'}
      href={ROUTES.CONSENT_PERSONAL_DATA}
    >
      обработку персональных данных
    </Link>
  </div>
);
